export default __webpack_public_path__ + "img/background.8df3c2a7.svg";